import * as React from 'react';
import { observer } from 'mobx-react';

import { DropdownView } from 'src/core/ui/dropdown.view';

interface LanguageEditorViewProps {
	languageRequest: DropdownRequest<LanguageSummary>;
	value: string | null;
	mode: ControlMode;
	onChanged: (number: string | null) => void;
	label?: string;
	required?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
}

@observer
export class LanguageEditorView extends React.Component<LanguageEditorViewProps, any> {
	constructor(props) {
		super(props);
	}

	render() {
		let label = this.props.label;
		if (label === undefined) {
			label = 'Language';
		}

		return (
			<DropdownView
				label={label}
				model={this.props.value}
				onGetErrorMessage={this.props.onGetErrorMessage}
				disabled={this.props.mode == 'display'}
				required={this.props.required}
				onChanged={(item) => {
					this.props.onChanged(item != null ? item.languageCode : null);
				}}
				request={this.props.languageRequest}
				keyField="languageCode"
				textField="displayName"
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/language/parts/language-editor.view.tsx